import React, { Component } from 'react';
import { map } from 'lodash';
import { message } from "antd";

import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import AccountOverview from "./Service/AccountOverview";
import AccountDetails from "./Service/AccountDetails";
import Proposal from "./Service/Proposal/Proposal";
import Loader from "../../../Common/Component/Loader";
import CustomerDrawerCollapse from './CustomDrawer/CustomerDrawerCollapse';
import CustomDrawer from "./CustomDrawer/CustomDrawer";
import {errorHandle} from "../../../Common/errorHandle";

const tabs = [
  'Account Overview',
  'Account Details',
  'Proposals'
];


class ProposalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 0,
      proposal: {},
      callLog: {},
      loader: false,
      accountNotes: {},
      errors: {},
      seriveAggrBtn: false,
      modalShow: false,
      quoteDetail: {},
      showSidebar: true,
      isExpandPanel: false
    }
  }

  componentDidMount = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    if (id) {
      this.setState({ loader: true });
      this.props.getQuoteById(id) // get quote detail
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    const { callLog } = this.state;
    // errors
    if (Object.keys(nextProps?.AccountNotes?.errors).length > 0 && nextProps?.AccountNotes?.errors !== this.props?.AccountNotes?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.AccountNotes?.errors)
    }

    if (Object.keys(nextProps?.CommercialProposal?.errors).length > 0 && nextProps?.CommercialProposal?.errors !== this.props?.CommercialProposal?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CommercialProposal?.errors)
    }
    ///////////////////////////////////////////////////////////////

    // get quote detail
    if (Object.keys(nextProps?.CommercialProposal?.getQuoteDetail).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.getQuoteDetail) !== JSON.stringify(this.props?.CommercialProposal?.getQuoteDetail)) {
      this.setState({ quoteDetail: nextProps?.CommercialProposal?.getQuoteDetail });
      // console.log("nextProps::::>",nextProps)
    }

    // get call logs
    if (Object.keys(nextProps?.CallLog?.logList).length > 0 &&
      JSON.stringify(nextProps?.CallLog?.logList) !== JSON.stringify(this.props?.CallLog?.logList)) {
      this.setState({ callLog: nextProps?.CallLog?.logList });
    }

    // add call logs
    if (Object.keys(nextProps?.CallLog?.log).length > 0 &&
      JSON.stringify(nextProps?.CallLog?.log) !== JSON.stringify(this.props?.CallLog?.log)) {
      this.setState({ callLog: { ...callLog, results: [...(callLog?.results || []), nextProps?.CallLog?.log] } });
    }
    this.setState({ loader: false });
  }

  onSingleService = () => {
    this.setState((prevState) => ({ seriveAggrBtn: !prevState.seriveAggrBtn }))
  }

  toggleModal = () => {
    this.setState((prevState) => ({ modalShow: !prevState.modalShow }))
  }

  toggleSidebar = (value) => {
    if (value !== this.state.showSidebar) this.setState({ showSidebar: value })
  }

  // tab change
  tabChange = (e) => {
    this.setState({
      currentTab: e
    });
    if (e !== 2) this.setState({ showSidebar: true })
  };

  // render tab
  renderTab = () => {
    const { currentTab } = this.state;
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    const detail = history?.location?.state?.query?.detail;

    switch (currentTab) {
    case 0:
      return <AccountOverview
        quoteId={id}
        history={history}
        quoteDetail={detail} // main quote detail that we select from main list
        tabChange={this.tabChange}

        // APIs
        getQuoteById={this.props.getQuoteById}
        getCommercialProposal={this.props.getCommercialProposal}
        //Reducers
        CommercialProposal={this.props.CommercialProposal}
      />
    case 1:
      return (<AccountDetails
        quoteId={id}
        history={history}
        quoteDetail={detail} // main quote detail that we select from main list
        tabChange={this.tabChange}

        // APIs
        getQuoteById={this.props.getQuoteById}
        getCommercialProposal={this.props.getCommercialProposal}
        //Reducers
        CommercialProposal={this.props.CommercialProposal}
      />)
    case 2:
      return <Proposal
        quoteId={id}
        history={history}
        quoteDetail={detail} // main quote detail that we select from main list
        toggleSidebar={this.toggleSidebar}

        // API
        getQuoteById={this.props.getQuoteById}
        addCommercialProposal={this.props.addCommercialProposal}
        addInnerCommercialProposal={this.props.addInnerCommercialProposal}
        updateInnerCommercialProposal={this.props.updateInnerCommercialProposal}
        getCommercialProposal={this.props.getCommercialProposal}
        getCommercialProposalById={this.props.getCommercialProposalById}
        patchCommercialProposal={this.props.patchCommercialProposal}
        sendProposalMail={this.props.sendProposalMail}
        getProposalPdf={this.props.getProposalPdf}
        checkEmail={this.props.checkEmail}
        deleteProposalLineItems={this.props.deleteProposalLineItems}
        deleteInnerProposal={this.props.deleteInnerProposal}
        getBDA={this.props.getBDA}
        editFieldOffice = {this.props.editFieldOffice}

        // Reducers
        CommercialProposal={this.props.CommercialProposal}
        EditFieldOffice = {this.props.EditFieldOffice}
      />
    default:
      return <AccountOverview />
    }
  }

  expandCollapse = (isExpand) => {
    this.setState({
      isExpandPanel: isExpand
    })
  }

  render() {
    const { currentTab, loader, quoteDetail, showSidebar, isExpandPanel } = this.state;
    const { history } = this.props;
    // const id = history?.location?.state?.query?.id;
    const detail = history?.location?.state?.query?.detail;
    const name = detail?.first_name ? `${detail?.first_name} ${detail?.last_name}` : '';

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header placeholder={'Acc Number , HOA , Community Manager & Phone Number'} />

          {/* Sidebar */}
          <Sidebar />

          <div className="container">
            {loader && <Loader />}
            <div className={showSidebar ? `md-container` : ''}>
              <div className="filter_wrapper">
                <ul className="breadcrumb">
                  <li className={"cursor_pointer"}><span onClick={() => this.props.history.goBack()}>Proposal</span></li>
                  <li><span>{name}</span></li>
                </ul>
              </div>
              <div className="residential-wrapper">
                <div className="res-head pb-0">
                  <div className="flex ai-center mb-20">
                    <div className="user-info no-border">
                      <h3>{name}</h3>
                      <span className={`status warning`}>Proposal</span>
                    </div>

                    <div className="user-detail">
                      {this.state.seriveAggrBtn ? <button className="btn btn-warning mt-20 mb-10" style={{ marginLeft: "140px" }} onClick={() => this.toggleModal()}>View Service Aggreement</button> : null}
                    </div>
                  </div>
                  <ul className="tabs dark">
                    {
                      map(tabs, (item, index) =>
                        <li key={`tab${index}`} className={currentTab === index ? 'active' : ''} onClick={(e) => { e.preventDefault(); if (index !== 3) { this.setState({ seriveAggrBtn: false }) } this.tabChange(index) }}>
                          <span className="flex ai-center">
                            {item}
                          </span>
                        </li>
                      )
                    }
                  </ul>
                </div>
                <div className="res-body">
                  {this.renderTab()}
                </div>
              </div>
            </div>
            {showSidebar && !isExpandPanel ? <div className="side-drawer-collapsed">
              <CustomerDrawerCollapse
                expandCollapse={this.expandCollapse}
              />
            </div> : ''}

            {showSidebar && isExpandPanel ? <div className="side-drawer rdrawer-expanded">
              <CustomDrawer
                customerId={quoteDetail?.user_uuid}
                CallLog={this.props.CallLog} // reducer
                getCallLogList={this.props.getCallLogList}
                addCallLog={this.props.addCallLog}
                updateCallLog={this.props.updateCallLog}
                getAccountNotes={this.props.getAccountNotes}
                addAccountNotes={this.props.addAccountNotes}
                AccountNotes={this.props.AccountNotes}
                query={this?.props?.location?.state?.query}
                RepresentativeList={this.props.RepresentativeList} // reducer
                getRepresentativeList={this.props.getRepresentativeList}
                expandCollapse={this.expandCollapse}
              />
            </div> : ''}
          </div>
        </div>
      </div>
    );
  }
}

export default ProposalDetail;
